import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Body, Popup } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { forwardRef } from 'react';
const styledFooterCss = "s2owpvx";
const StyledFooter = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledFooterCss, props.className)} />;
});
export const MeetingIntelligenceDisableModal = ({
  onClose,
  onConfirm,
  handleTrackModal
}) => <Popup data-testid="mi-disable-modal" onClose={() => {
  onClose();
  handleTrackModal('disableModalDismiss', {
    action: 'dismissed'
  });
}} title={I18n.t('publisher.account_settings.meeting_intelligence.modal.title')} withCloseButton>
    <Body>
      {HtmlParser(I18n.t('publisher.account_settings.meeting_intelligence.modal.disable.body_text'))}
    </Body>
    <StyledFooter>
      <Button decoration="secondary-outline" onClick={() => {
      onClose();
      handleTrackModal('disableModalDismiss', {
        action: 'cta_dismissed'
      });
    }}>
        {I18n.t('publisher.account_settings.meeting_intelligence.modal.nevermind')}
      </Button>
      <Button decoration="danger" onClick={onConfirm}>
        {HtmlParser(I18n.t('publisher.account_settings.meeting_intelligence.modal.disable.remove_notetaker'))}
      </Button>
    </StyledFooter>
  </Popup>;

require("./meeting_intelligence_disable_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_intelligence_disable_modal.js");